import './styles/style.less';
import React from 'react';
import { createRoot } from "react-dom/client";
import App from './components/Root';

const root = createRoot(document.getElementById("root"));
root.render(<App />);
